import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '../../modules/material.module';
import { ReactiveFormsModule } from '@angular/forms';

import { DialogContainerComponent } from './dialog-container/dialog-container.component';
import { DialogConfirmationComponent } from './dialog-confirmation/dialog-confirmation.component';
import { ShareInstitutionDialogComponent } from './share-institution-dialog/share-institution-dialog.component';

const sharedComponents = [
  DialogContainerComponent,
  DialogConfirmationComponent,
  ShareInstitutionDialogComponent
];

@NgModule({
  imports: [CommonModule, MaterialModule, ReactiveFormsModule],
  declarations: [...sharedComponents],
  exports: [...sharedComponents]
})
export class DialogModule {}
